/**
 * @module cercaliagl/data
 */
import { LANG } from './globals';
import Servers from './servers';
import Service from './service/Service';

/**
 * @type {!Array.<Array.<string>>}
 */
let countries = [];

/**
 * @type {!Array.<Array.<string>>}
 */
let categories = [];

/**
 * @param {Function} callbackFn Callback function.
 */
export function getCountries(callbackFn) {
  const params = {
    data: 'countries',
    lang: LANG,
  };

  if (countries.length === 0) {
    new Service({ url: Servers.dataServlet }).getRequest({
      data: params,
      callbackFn: (data) => {
        countries = data;
        callbackFn(data);
      },
    });
  } else {
    callbackFn(countries);
  }
}

/**
 * @param {Function} callbackFn Callback function.
 */
export function getCategories(callbackFn, lang = LANG) {
  const params = {
    data: 'categories',
    lang,
  };

  if (categories.length === 0) {
    new Service({ url: Servers.dataServlet }).getRequest({
      url: Servers.dataServlet,
      data: params,
      callbackFn: (data) => {
        categories = data;
        callbackFn(data);
      },
    });
  } else {
    callbackFn(categories);
  }
}

export default {};
